import {i18n} from "@lingui/core";
import { DEFAULT_AD_IMAGE } from "../constants.js";

type AdImageWithDefaultProps = {
    alt?: string;
    image?: string;
    isMobile?: boolean;
    numberOfAds?: number | undefined;
    roundedBorder?: boolean;
    sizeStyleClasses?: string;
    textSize?: string
}

const AdImageWithDefault = (props: AdImageWithDefaultProps) => {
    const {isMobile, image, numberOfAds, alt, sizeStyleClasses, roundedBorder = false, textSize = 'text-xxl'} = props;
    const defaultSizeStyleClasses = isMobile ? 'w-48 h-48' : 'w-80 h-80';
    const sizeClasses = sizeStyleClasses ?? defaultSizeStyleClasses;
    const roundedClass = roundedBorder ? "rounded-8" : "";
    const altText = alt || i18n._({
        id: 'alt.defaultImage',
        comment: 'Alt-text on the default ad image shown when the seller has not uploaded a picture.',
        message: 'Standard ad image illustrated with a minimalist illustration of mountains and clouds in blue tones',
    })

    return (
        <div className={`${roundedClass} relative flex justify-center self-center ${sizeClasses}`}>
            <img
                className={`object-cover h-full w-full ${roundedBorder ? "rounded-8 outline outline-1 outline-[--w-black/15] -outline-offset-1" : ""}`}
                src={image || DEFAULT_AD_IMAGE}
                alt={altText}
            />
            {numberOfAds && numberOfAds > 0 && (
                <>
                    <div
                        className={`absolute inset-0 s-bg-inverted opacity-50 ${roundedClass}`}
                    />
                    <p
                        className={`absolute inset-0 flex items-center justify-center s-text-inverted m-0 ${textSize}`}
                        aria-label={`${numberOfAds} ${i18n._({
                            id: 'image.overlay',
                            comment: 'Screen reader text for an image overlay about number of items in a bundle, prefixed with number',
                            message: 'items in bundle',
                        })}`}
                    >
                        {numberOfAds}
                    </p>
                </>
            )}
        </div>
    );
}

export default AdImageWithDefault;